og-app {
  .top-banner {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: calc(var(--ion-safe-area-top) + 40px);
    z-index: 100000;

    text-align: center;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    cursor: pointer;
    > div {
      padding-bottom: 10px;
    }
    &.demo-banner {
      background: var(--ion-color-primary);
    }
    &.delete-account-banner {
      background: var(--ion-color-danger);
    }
  }
  ion-ripple-effect {
    overflow: hidden;
  }
  ion-app.og-keyboard-shown {
    --ion-safe-area-bottom: 0px;
  }
}
